import { useDispatch, useSelector } from 'react-redux'

import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import CampaignIcon from '@mui/icons-material/Campaign'
import ChatBubbleIcon from '@mui/icons-material/ChatBubble'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import { Box, Drawer, Fab, IconButton, useTheme } from '@mui/material'

import { RootState } from 'redux/store'
import { toggleSidebar } from 'redux/ui/common/themeUI'
import { toggleAnnouncements, toggleCalendar } from 'redux/ui/sidebarUI'

import Calendar from 'components/molecules/Calendar'
import AnnouncementsList from 'components/utilized/announcements/AnnouncementsList'

import { ASIDE_WIDTH, HEADER_HEIGHT } from 'utils/customizedTheme'

import Modal from '../modals/Modal'

import chatIcon from 'assets/images/icons/chat-icon.png'
import { useTranslation } from 'react-i18next'

const SideBar = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  const dispatch = useDispatch()

  const openSidebar = useSelector((state: RootState) => state.theme.openSidebar)
  const openAnnouncements = useSelector((state: RootState) => state.sidebar.openAnnouncements)
  const openCalendar = useSelector((state: RootState) => state.sidebar.openCalendar)
  const ICON_SIZE = '2.25rem'

  return (
    <>
      <Drawer
        sx={{
          width: '25rem',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          zIndex: theme.zIndex.appBar - 1,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: ASIDE_WIDTH,
            height: '100%',
            boxSizing: 'border-box',
            overflow: 'hidden',
          },
        }}
        variant='persistent'
        hideBackdrop={true}
        anchor='right'
        open={openSidebar}
        onClose={() => dispatch(toggleSidebar())}
      >
        <Box sx={{ minHeight: HEADER_HEIGHT }} />
        <IconButton
          color='inherit'
          sx={{ width: '3.5rem', height: '3.5rem', margin: '1.5rem auto 0.5rem', color: 'rgba(0,0,0,0.3)' }}
          onClick={() => dispatch(toggleCalendar())}
        >
          <CalendarMonthIcon sx={{ fontSize: ICON_SIZE }} />
        </IconButton>

        {/*
        <IconButton
          color='inherit'
          sx={{ width: '3.5rem', height: '3.5rem', margin: '1rem auto 0.5rem', color: 'rgba(0,0,0,0.3)'  }}
          onClick={() => {}}
        >
          <img src={chatIcon} style={{ height: '30px', opacity: '0.3' }} />
        </IconButton>
        */}
        
        <IconButton
          color='inherit'
          sx={{ width: '3.5rem', height: '3.5rem', margin: '1rem auto 0.5rem', color: 'rgba(0,0,0,0.3)'  }}
          onClick={() => dispatch(toggleAnnouncements())}
        >
          <CampaignIcon sx={{ fontSize: ICON_SIZE }} />
        </IconButton>
      </Drawer>
      {openSidebar !== null && (
        <Fab
          color={openSidebar ? 'white' : 'primary'}
          aria-label='toggle'
          onClick={() => dispatch(toggleSidebar())}
          sx={{
            boxShadow: openSidebar ? 'none' : null,
            zIndex: '1201',
            position: 'absolute',
            bottom: '1rem',
            right: '0.7rem',
            color: '#000',
          }}
        >
          {openSidebar ? (
            <KeyboardArrowRightIcon sx={{ fontSize: '2.75rem' }} />
          ) : (
            <KeyboardArrowLeftIcon sx={{ fontSize: '2.75rem' }} />
          )}
        </Fab>
      )}
      {openCalendar && (
        <Modal toggleModal={toggleCalendar} openModal={openCalendar} width='80vw' entityName='Calendar'>
          <Calendar loadSessions={true} loadMilestones={true} loadMeetings={true} />
        </Modal>
      )}
      {openAnnouncements && (
        <Modal
          toggleModal={toggleAnnouncements}
          openModal={openAnnouncements}
          width='820px'
          entityName={t('common.announcements')}
        >
          <AnnouncementsList />
        </Modal>
      )}
    </>
  )
}

export default SideBar
